var React = require('react');

function Check1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.374.287a1.5,1.5,0,0,0-2.093.345L7.246,20.2,2.561,15.511A1.5,1.5,0,1,0,.439,17.632l5.935,5.934a1.525,1.525,0,0,0,2.279-.186l15.066-21A1.5,1.5,0,0,0,23.374.287Z","fill":"currentColor"}));
}

Check1.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Check1;

Check1.default = Check1;
